import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addTag: {
    description: 'tagSelector.editTag',
    defaultMessage: 'Edit Tags',
    id: '2oWMDb',
  },
  manageTags: {
    description: 'tagDropdownManageTagTitle',
    defaultMessage: 'Manage Tags',
    id: 'xenmAh',
  },
});
